<div *ngIf="isLoading | async" class="spinner-overlay">
  <mat-spinner></mat-spinner>
</div>
<router-outlet></router-outlet>
